var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('Navbar'),_c('ChatbotComponent',{attrs:{"messages":_vm.messages,"isGenerating":_vm.isGenerating},on:{"onPrompt":_vm.sendPrompt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }